import { Injectable } from '@angular/core';
import {LogLocalStorage, LogPublisher} from "./log-publishers";
import { LogPublishersService }
  from "./log-publishers.service";
import {HttpClient} from "@angular/common/http";
import {Events} from "ionic-angular";

@Injectable()

export class LogService {
  level: LogLevel = LogLevel.All;
  logWithDate: boolean = true;
  publishers: LogPublisher[];
  public storageLogging: boolean = false;
  public readonly storageLogLocation = "storageLogging";
  constructor(
    private publishersService: LogPublishersService,
    private http: HttpClient,
    private events: Events) {
    // Set publishers
    this.publishers = this.publishersService.publishers;
    // check if storage logging is enabled
    localStorage.getItem(this.storageLogLocation) ? this.enableStorageLogging() : this.disableStorageLogging();
  }
  debug(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Debug, optionalParams);
  }

  info(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Info, optionalParams);
  }

  warn(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Warn, optionalParams);
  }

  error(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Error, optionalParams);
  }

  fatal(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.Fatal, optionalParams);
  }

  log(msg: string, ...optionalParams: any[]) {
    this.writeToLog(msg, LogLevel.All, optionalParams);
  }

  private writeToLog(msg: string, level: LogLevel, params: any[]) {
    if (this.shouldLog(level)) {
      let entry: LogEntry = new LogEntry();
      entry.message = msg;
      entry.level = level;
      entry.extraInfo = params;
      entry.logWithDate = this.logWithDate;
      for (let logger of this.publishers) {
        logger.log(entry).subscribe(response => {
        });
      }
    }
  }

  sendToCloud(practiceId: string) {
    for (let logger of this.publishers) {
      logger.sendToCloud(practiceId).subscribe(response => {
      });
    }
  }

  enableStorageLogging() {
    if(this.storageLogging) return;
    this.publishers.push(new LogLocalStorage(this.http, this.events));
    this.storageLogging = true;
    localStorage.setItem(this.storageLogLocation, "true");
  }

  disableStorageLogging() {
    this.publishers = this.publishers.filter(p => !(p instanceof LogLocalStorage));
    this.storageLogging = false;
    localStorage.removeItem(this.storageLogLocation);
  }

  private shouldLog(level: LogLevel): boolean {
    let ret: boolean = false;
    if ((level >= this.level && level !== LogLevel.Off) || this.level === LogLevel.All) {
      ret = true;
    }
    return ret;
  }
}

export class LogEntry {
  // Public Properties
  entryDate: Date = new Date();
  message: string = "";
  level: LogLevel = LogLevel.Debug;
  extraInfo: any[] = [];
  logWithDate: boolean = true;

  buildLogString(): string {
    let ret: string = "";

    if (this.logWithDate) {
      ret = new Date() + " - ";
    }

    ret += "Type: " + LogLevel[this.level];
    ret += " - Message: " + this.message;
    if (this.extraInfo.length) {
      ret += " - Extra Info: " + this.formatParams(this.extraInfo);
    }

    return ret;
  }

  private formatParams(params: any[]): string {
    let ret: string = params.join(",");

    // Is there at least one object in the array?
    if (params.some(p => typeof p == "object")) {
      ret = "";

      // Build comma-delimited string
      for (let item of params) {
        ret += JSON.stringify(item) + ",";
      }
    }

    return ret;
  }
}

export enum LogLevel {
  All = 0,
  Debug = 1,
  Info = 2,
  Warn = 3,
  Error = 4,
  Fatal = 5,
  Off = 6
}



// WEBPACK FOOTER //
// ./src/providers/logging/log.service.ts